import { createAsyncThunk } from "@reduxjs/toolkit";
import { useCustomAxios } from "../../shared/lib/customAxios";
import { API_ENDPOINTS } from "../../shared/constants/constants";

export const getAllProformaInvoice = createAsyncThunk(
  'proformaInvoice/getAll',
  async (queryParams: any) => {
    const { axiosGet } = useCustomAxios();
    try {
      let url = API_ENDPOINTS.getAllProformaInvoice;
      Object.entries(queryParams).forEach(
        ([key, value], index) =>
          (url = url + `${index > 0 ? '&' : '?'}${key}=${encodeURIComponent(value as string ?? '')}`)
      );
      const response = await axiosGet(url);

      return { data: response.data, status: response.status };
    } catch (error: any) {
      return {
        error: error.response.data.message,
        status: error.response.status,
      };
    }
  }
)

export const getProformaInvoiceById = createAsyncThunk(
  'proformaInvoice/getById',
  async (proformaInvoiceId: string) => {
    const { axiosGet } = useCustomAxios();
    try {
      let url = API_ENDPOINTS.getProformaInvoiceById;
      url = url.replace(":proformaInvoiceId", proformaInvoiceId);
      const response = await axiosGet(url);

      return { data: response.data, status: response.status };
    } catch (error: any) {
      return {
        error: error.response.data.message,
        status: error.response.status,
      };
    }
  }
)

export const downloadProformaInvoicePdf = createAsyncThunk(
  "proformaInvoice/downloadpdf",
  async (reqBody: any) => {
    const { axiosPost } = useCustomAxios();
    let url = API_ENDPOINTS.downloadProformaInvoicePdf;
    try {
      const response = await axiosPost(url, reqBody);
      const downloadURL = response.data.downloadUrl;
      const downloadLink = document.createElement("a");
      document.body.appendChild(downloadLink);
      downloadLink.href = downloadURL;
      downloadLink.download = "proformaInvoice.pdf";
      downloadLink.target = "_blank";
      downloadLink.click();
      document.body.removeChild(downloadLink);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      console.log(error);
      return {
        error: error.response.data.message,
        status: error.response.status,
      };
    }
  }
);